import Color from 'color'
import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { common, modals } from '@ocean/ui'

const { SectionTitle } = common
const { ModalOverlay, ModalBackdrop, ModalDialog } = modals.common.modalsStyled

export const Overlay = styled(ModalOverlay)`
  position: absolute;
  z-index: 30;

  ${({ theme }) => `
    color: ${theme.color.white};
  `}
`

export const Backdrop = styled(ModalBackdrop)`
  z-index: 31;
`

export const Dialog = styled(ModalDialog)`
  min-height: 100%;
  transition: all 0.2s ease-out;

  ${({ theme }) => `
    padding:
      calc(${theme.space.mobile.large} + ${theme.space.mobile.tiny})
      ${theme.space.mobile.base}
      calc(${theme.space.mobile.huge} + ${theme.space.mobile.tiny});

    a,
    a:link,
    a:visited {
      color: ${theme.color.oceanLight};
    }
    
    a:hover,
    a:focus {
      color: ${Color(theme.color.oceanLight).darken(0.15).string()};
    }
  `}

  ${({ theme }) => media.sm`
    min-height: 0;
    padding:
      ${theme.space.desktop.base}
      calc(${theme.space.desktop.base} + ${theme.space.desktop.small})
      calc(${theme.space.desktop.base} + ${theme.space.desktop.tiny});
  `}
`

export const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > div[data-selector='Decorator'] {
    min-height: 100%;
    height: 100%;
    margin: 0;
    transition: all 0.2s ease-out;
    width: 100%;
  }

  ${media.sm`
    div[data-selector='Decorator'] {
      width: 976px;
      min-height: 0;
      height: auto;
      margin: 30px;
    }
  `}
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.base};
  `}
`

export const Title = styled(SectionTitle)`
  margin: 0;
  flex-grow: 1;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex-grow: 1;
`
